const classes = {
  wrapper: 'w-full md:w-8/12',
  content: 'bg-background p-5 mb-10',
  controls: 'mt-5 flex items-center justify-center',
  list: 'flex flex-col gap-5',
} as const;
export default classes;
